<!--
 * @Description: 设备分类
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-19 15:07:01
 * @LastEditTime: 2024-06-07 10:19:05
-->
<template>
<div class="statisticalChartsContainer">
  <!-- 设备分类 -->
  <div class="chartItem">
    <div class="itemBox">
      <!-- 设备类型个数 -->
      <h4>{{total}}</h4>

      <div class="chartBox" :id="idName">
        <echarts :chart-id="idName" :chart-option="options"></echarts>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import * as echarts from 'echarts'
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      total: 0,
      options: {
        tooltip: {
          trigger: 'item',
          confine: true
        },
        color: ['#13DA93', '#2899FE', '#FFBD1F', '#FFEA00', '#3FFFEA', '#14E5C4', '#A8740C', '#3096C6', '#623FD5', '#EAC6BF', '#D43067'],
        series: [
          {
            name: '设备类型',
            type: 'pie',
            radius: ['40%', '55%'],
            label: {
              show: true,
              color: '#fff',
              formatter: '{b|{b}}\n{per|{d}%}  ',
              rich: {
                b: {
                  color: '#fff',
                },
                per: {
                  color: '#03D1F8'
                }
              }
            },
            data: [],
          },
          // 外环装饰，没有实际含义
          {
            name: '',
            type: 'pie',
            radius: ['65%', '69%'],
            label: { show: false },
            emphasis: { scale: false },
            tooltip: { show: false },
            data: [
              { value: 70, name: '', itemStyle: { color: 'rgba(16, 41, 90, 0.5)' } }
            ],
          }
        ]
      }
    }
  },
  created() {
    this.getEchartsList()
  },
  computed: {
    idName() {
      return this.flag ? "echartsId5_big" : "echartsId5"
    },
    styleObj() {
      return this.flag ? {
        radius: [250, 240],
        graphic: {
          width: 400,
          height: 400
        },
        length: 30,
        length2: 30,
        fontSize: 60,
        labelFontsize: 30
      } : {
        radius: [60, 62],
        graphic: {
          width: 80,
          height: 80
        },
        length: 2,
        length2: 5,
        fontSize: 14,
        labelFontsize: 12

      }
    }
  },
  mounted() {},
  methods: {
    initStyle() {
      this.options.series[0].radius = this.styleObj.radius
      this.options.series[0].itemStyle.normal.labelLine.length = this.styleObj.length
      this.options.series[0].itemStyle.normal.labelLine.length2 = this.styleObj.length2
      this.options.series[0].itemStyle.normal.label.fontSize = this.styleObj.labelFontsize
      this.options.title.textStyle.fontSize = this.styleObj.fontSize
      this.options.graphic.elements[0].style.width = this.styleObj.graphic.width
      this.options.graphic.elements[0].style.height = this.styleObj.graphic.height
    },
    async getEchartsList() {//设备分类
      let { data, msg, code } = await this.request.post('/front/device/inwareStatistics')
      if (code != 200) return
      let options = JSON.parse(JSON.stringify(this.options))

      if (data == null || data.length <= 0) {
        // 没数据时造假数据0
        data = [
          { deviceTypeName: "可燃气体探测器", count: 0 },
          { deviceTypeName: "烟雾报警器", count: 0 },
          { deviceTypeName: "液位", count: 0 },
          { deviceTypeName: "水压", count: 0 },
          { deviceTypeName: "门磁", count: 0 },
          { deviceTypeName: "空开", count: 0 },
          { deviceTypeName: "小工报", count: 0 },
          { deviceTypeName: "一键报警", count: 0 }
        ]
      }

      let seriesData = []
      let titleData = data.length || 0
      seriesData = data.map(({ count, deviceTypeName }) => {
        return { value: count, name: deviceTypeName }
      })

      options.series[0].data = seriesData
      this.total = titleData > 999999 ? '99999+' : titleData

      // 内环装饰，没有实际含义
      let inCircalSeries = JSON.parse(JSON.stringify(options.series[1]))
      let temp = []
      inCircalSeries.radius = ['30%', '35%']
      for(let i = 0; i <= 99; i ++) {
        let color = i % 2 === 0 ? '#112C60' : 'transparent'
        temp.push({
          value: 1,
          name: '',
          itemStyle: { color }
        })
      }
      inCircalSeries.data = temp
      options.series.push(inCircalSeries)

      this.options = options
    },
    initConfig(trafficWay) {
      // var trafficWay = [{
      //   name: '无线烟感 1',
      //   value: 20
      // }, {
      //   name: '无线烟感 2',
      //   value: 10
      // }, {
      //   name: '电气火灾控制器',
      //   value: 50
      // }, {
      //   name: '无线可燃气体',
      //   value: 30
      // }];
      var data = [];
      var color = ['#00ffff', '#00cfff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000']
      for (var i = 0; i < trafficWay.length; i++) {
        data.push({
          value: trafficWay[i].value,
          name: trafficWay[i].name,
          itemStyle: {
            normal: {
              borderWidth: 5,
              shadowBlur: 20,
              borderColor: color[i],
              shadowColor: color[i]
            }
          }
        }, {
          value: 2,
          name: '',
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              color: 'rgba(0, 0, 0, 0)',
              borderColor: 'rgba(0, 0, 0, 0)',
              borderWidth: 0
            }
          }
        });
      }
      let itemStyle = {
        normal: {
          label: {
            show: true,
            position: 'outside',
            color: '#ddd',
            fontSize: 12,
            // formatter: function (params) {
            //   var percent = 0;
            //   var total = 0;
            //   for (var i = 0; i < trafficWay.length; i++) {
            //     total += trafficWay[i].value;
            //   }
            //   percent = ((params.value / total) * 100).toFixed(2);
            //   if (params.name !== '') {
            //     return params.name + '\n' + '\n' + '占比：' + percent + '%';
            //   } else {
            //     return '';
            //   }
            // },
          },
          labelLine: {
            length: 10,
            length2: 10,
            show: true,
            color: '#00ffff'
          }
        }
      }
      this.options.tooltip.formatter=function (params) {
              var percent = 0;
              var total = 0;
              for (var i = 0; i < trafficWay.length; i++) {
                total += trafficWay[i].value;
              }
              percent = ((params.value / total) * 100).toFixed(2);
              if (params.name !== '') {
                return params.name + '\n' + '\n' + '占比：' + percent + '%';
              } else {
                return '';
              }
            }
      this.options.title.text = trafficWay.length+ "个"
      this.options.series[0].itemStyle = itemStyle
      this.options.series[0].data = data
      this.initStyle()

      console.log(`this.options`, this.options)
      // this.listData = data
    }
  }
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  font-size: 0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;  

  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;
      position: relative;
      h4 {
        position: absolute;
        top: 45%;
        left: 50%;
        color: #fff;
        font-size: 16px;
        width: 70px;
        margin-left: -35px;
        overflow: hidden;
        font-family: 'PMZD';
        color: #02D9FD;
      }

      .chartBox {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
